module.exports = __webpack_public_path__ + "static/dictionary20201-a9cd38ba877e2e80e135d091552abc5e.png";